import React, { useState, useRef, forwardRef, useImperativeHandle, useEffect } from "react"
import { Box, Typography, DialogActions, DialogContent, Grid } from "@mui/material"
import TextInputComponent from "../../atom/Inputs/TextInput"
import TextButtonComponet from "../../atom/Buttons/TextButton"
import { MINIMUM_PASSWORD_CHARACTERS, USER_ROLE, EMAIL_REGEX, getText, getDeviceId, PASSWORD_REGEX, PHONE_REGEX, OTP_LENGTH } from "../../../core/Constant";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { Actions } from "../../../core/modules/Actions";
import CardValidator from 'card-validator';
import _ from "lodash";
import PhoneNumberComponent from "../../atom/Inputs/PhoneNumberInput";
import { parsePhoneNumber, isPossiblePhoneNumber, isValidPhoneNumber } from 'react-phone-number-input'
import Repository from "../../../core/repository/Repository";

// Create an instance of Repository to access its URL
const repository = new Repository();

const SignUpFormOne = forwardRef(({ 
    onPassValue = () => { }, 
    isFree = 0, 
    course_id, 
    selectedCurrency, 
    courseType,  
    onUpdateValue = () => {},
    onEmailVerified = () => {}
}, ref) => {
    const navigate = useNavigate();
    const dispatch = useDispatch();

    // Email state
    const [email, setEmail] = useState('');
    const [isEmailValid, setIsEmailValid] = useState(false);
    const [emailError, setEmailError] = useState(false);
    const [emailErrorMessage, setEmailErrorMessage] = useState('');
    
    // OTP state
    const [otp, setOtp] = useState('');
    const [otpToken, setOtpToken] = useState('');
    const [isOtpSent, setIsOtpSent] = useState(false);
    const [isEmailVerified, setIsEmailVerified] = useState(false);
    const [otpError, setOtpError] = useState('');
    const [isSendingOtp, setIsSendingOtp] = useState(false);
    const [isVerifyingOtp, setIsVerifyingOtp] = useState(false);
    const [otpResendTime, setOtpResendTime] = useState(0);
    const [showResendLink, setShowResendLink] = useState(false);

    const [password, setPassword] = useState('');
    const [isPasswordValid, setIsPasswordValid] = useState(false);
    const [errorPassword, setPasswordError] = useState(false);
    const [isPasswordSecure, setIsPasswordSecure] = useState(true);

    const [confirmPassword, setConfirmPassword] = useState('');
    const [isConfirmPasswordValid, setIsConfirmPasswordValid] = useState(false);
    const [ConfirmPasswordError, setConfirmPasswordError] = useState(false);
    const [isConfirmPasswordSecure, setIsConfirmPasswordSecure] = useState(true);

    const [fName, setFName] = useState('');
    const [isFNameValid, setIsFNameValid] = useState(false);
    const [fNameError, setFNameError] = useState(false);

    const [lName, setLName] = useState('');
    const [isLNameValid, setIsLNameValid] = useState(false);
    const [lNameError, setLNameError] = useState(false);

    const [phone, setPhone] = useState('');
    const [isPhoneValid, setIsPhoneValid] = useState(false);
    const [phoneError, setPhoneError] = useState(false);
    const [countryCode, setCountryCode]=useState("+1");

    const verifyEmailData = useSelector(state => state.auth.get("verifyEmailData"));
    
    const [statusIndex, setStatusIndex] = useState(0)

    const [isShow, setIsShow] = useState(0);
    const show = useSelector(state => state.common.get('show'));


    useEffect(() => {

        if (verifyEmailData?.status && verifyEmailData?.status_code == 1) {
            setIsEmailValid(false);
            setEmailError(true)
            setEmailErrorMessage(verifyEmailData?.message)
        } else {
            setIsEmailValid(true);
            setEmailError(false)
        }
        setStatusIndex(0)
    }, [verifyEmailData, statusIndex]);

    

    const onChangeFirstName = (e) => {
        const text = getText(e)
        setFName(text);
        setFNameError(false);
        setIsFNameValid(text?.length > 0)
    }

    const onChangeLastName = (e) => {
        const text = getText(e)
        setLName(text);
        setLNameError(false);
        setIsLNameValid(text?.length > 0)
    }


    const onEmailChange = (e) => {
        const text = getText(e);
        const isValid = EMAIL_REGEX.test(text.trim());
        
        setEmail(text);
        setIsEmailValid(isValid);
        setEmailError(!isValid);
        setEmailErrorMessage("Please enter a valid email address");
        
        // Reset OTP state when email changes
        if (isOtpSent) {
            setIsOtpSent(false);
            setOtp('');
            setOtpError('');
        }
    }

    const handleSendOtp = async () => {
        if (!isEmailValid) {
            setEmailError(true);
            setEmailErrorMessage("Please enter a valid email address");
            return;
        }

        setOtpError('');
        setIsSendingOtp(true);
        
        try {
            console.log('Sending OTP to:', email);
            const response = await fetch(`${repository.url}auth/send-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({ email })
            });
            
            const result = await response.json();
            console.log('OTP send result:', result);
            
            if (!response.ok) {
                const errorMessage = result?.message || 'Failed to send OTP. Please try again.';
                console.error('OTP send error:', errorMessage);
                setOtpError(errorMessage);
                return;
            }
            
            const token = result?.data?.token;
            if (!token) {
                console.error('No token received in OTP response');
                setOtpError('Failed to initiate OTP. Please try again.');
                return;
            }
            
            setIsOtpSent(true);
            setShowResendLink(true);
            setOtpToken(token);
            setOtp(''); // Clear any previous OTP
            startOtpResendTimer();
            
            // Show success message
            console.log('OTP sent successfully');
        } catch (error) {
            console.error('OTP send exception:', error);
            setOtpError('Failed to send OTP. Please try again.');
        } finally {
            setIsSendingOtp(false);
        }
    };

    const handleVerifyOtp = async () => {
        if (otp.length !== 6) {
            setOtpError('Please enter a valid 6-digit OTP');
            return;
        }

        if (!otpToken) {
            setOtpError('Session expired. Please request a new OTP.');
            return;
        }

        setIsVerifyingOtp(true);
        setOtpError('');

        try {
            console.log('Verifying OTP:', { email, otp, token: otpToken });
            const response = await fetch(`${repository.url}auth/verify-otp`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                    'Accept': 'application/json',
                },
                body: JSON.stringify({ 
                    email, 
                    otp, 
                    token: otpToken 
                })
            });
            
            const result = await response.json();
            console.log('OTP verification result:', result);

            if (!response.ok) {
                const errorMessage = result?.message || 'Invalid OTP. Please try again.';
                console.error('OTP verification error:', errorMessage);
                setOtpError(errorMessage);
                return;
            }
            
            const isVerified = result?.data?.verified || false;
            if (isVerified) {
                console.log('OTP verified successfully');
                setIsEmailVerified(true);
                setOtpError('');
                // Reset OTP resend state
                setShowResendLink(false);
                setOtpResendTime(0);
                // Notify parent that email is verified
                onEmailVerified();
            } else {
                console.error('OTP verification failed');
                setOtpError('Invalid OTP. Please try again.');
            }
        } catch (error) {
            console.error('OTP verification exception:', error);
            setOtpError('Failed to verify OTP. Please try again.');
        } finally {
            setIsVerifyingOtp(false);
        }
    };

    const startOtpResendTimer = () => {
        setOtpResendTime(60); // 60 seconds cooldown
        const timer = setInterval(() => {
            setOtpResendTime((prevTime) => {
                if (prevTime <= 1) {
                    clearInterval(timer);
                    return 0;
                }
                return prevTime - 1;
            });
        }, 1000);
    };

    const handleResendOtp = () => {
        // Reset OTP state but keep the email
        setIsOtpSent(false);
        setShowResendLink(false);
        setOtp('');
        setOtpError('');
        handleSendOtp();
    };

    const onOtpChange = (e) => {
        const value = e.target.value.replace(/\D/g, '').slice(0, 6);
        setOtp(value);
        setOtpError('');
    };

   

    const onConfirmPassword = (e) => {
        const text = getText(e);
        setConfirmPassword(text);
        setConfirmPasswordError(false)

        let isValid = false;
        if (new String(text).valueOf() === new String(password).valueOf()) {
            isValid = true;
        }
        setIsConfirmPasswordValid(isValid)
    }

    const onPasswordChange = (e) => {
        const text = getText(e);
        // let isValid = text.trim().length > PASSWORD_MINIMUM_CHARACTERS;
        let isMoreThanEight = false, isASpecialCharacter = false, isANumber = false, isCapitalLetter = false, isSimpleLetter = false;

        // if (text?.length > 0) {
        //     isANumber = isNumber(text);
        //     isASpecialCharacter = isSpecialCharacter(text);
        //     isCapitalLetter = isUpperCase(text);
        //     isSimpleLetter = isLowerCase(text)
        // }

        let isValid = false;

        if (text.trim().length > MINIMUM_PASSWORD_CHARACTERS) {
            isMoreThanEight = true;
            isValid = true
            isValid = PASSWORD_REGEX.test(text.trim());
        }
        setPassword(text);
        setPasswordError(false);
        setConfirmPasswordError(false);

        setIsPasswordValid(isValid)
        let isConfirmeValid = false;
        if (
            new String(text).valueOf() === new String(confirmPassword).valueOf()
        ) {
            isConfirmeValid = true;
        }
        setIsConfirmPasswordValid(isConfirmeValid)
    }

    const onPhoneChange = (text) => {
        setPhone(text);
        let isValid = false;
        if (text?.length > 3) {
            //  isValid = PHONE_REGEX.test(text.trim());
            const phoneData= parsePhoneNumber(text)
            isValid = isPossiblePhoneNumber(text) && isValidPhoneNumber(text)
            setCountryCode(`+${_.get(phoneData,"countryCallingCode")}`)
        }

        setIsPhoneValid(isValid);
        setPhoneError(false)
    }



    useImperativeHandle(ref, () => ({
        onPress() {
            onNext();
        }
    }))

    const onNext = () => {
        if (!isEmailVerified) {
            setOtpError('Please verify your email with OTP first');
            return;
        }
        
        if (isEmailValid && isPasswordValid && isConfirmPasswordValid && isFNameValid && isLNameValid && isPhoneValid) {
            onPassValue({
                first_name: fName,
                last_name: lName,
                email,
                password,
                confirm_password: confirmPassword,
                is_free: isFree,
                type: 1,
                course_id,
                whatsapp_country_code:countryCode,
                whatsapp_phone_number:phone
            });
            
        } else {
            if (!isEmailValid) {
                setEmailError(true);
            }
            if (!isPasswordValid) {
                setPasswordError(true)
            }

            if (!isConfirmPasswordValid) {
                setConfirmPasswordError(true)
            }
            if (!isPhoneValid) {
                setPhoneError(true)

            }
            if (!isFNameValid) {
                setFNameError(true)

            }
            if (!isLNameValid) {
                setLNameError(true)
            }

        }
    }



    return (
        <>
            <p className="signup-title">Please <span style={{ color: 'rgb(152, 52, 240)' }}>Signup</span> {isShow? "to start purchasing the course": ''}</p>
            
            {/* Email Field with OTP */}
            <Box sx={{ position: 'relative', mb: 3 }}>
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 1 }}>
                        <Box sx={{ flexGrow: 1, mt: '8px' }}>
                            <TextInputComponent
                                fullWidth
                                label="Email"
                                placeholder="Enter your email address"
                                value={email}
                                onchange={onEmailChange}
                                error={emailErrorMessage}
                                isError={emailError}
                                disabled={isOtpSent && showResendLink}
                            />
                        </Box>
                        {(!isOtpSent && !isEmailVerified) && (
                            <Box sx={{ 
                                minWidth: '120px',
                                mt: '55px',
                                '& .MuiButton-root': {
                                    height: '56px',
                                    whiteSpace: 'nowrap',
                                    backgroundColor: 'primary.main',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: 'primary.dark',
                                    },
                                    '&:disabled': {
                                        backgroundColor: 'action.disabledBackground',
                                        color: 'action.disabled',
                                    },
                                },
                            }}>
                                <TextButtonComponet
                                    fullWidth
                                    text="Send OTP"
                                    onButtonClick={handleSendOtp}
                                    disabled={!isEmailValid || isSendingOtp}
                                    style={{
                                        height: '100%',
                                        fontSize: '14px',
                                        fontWeight: 500,
                                        textTransform: 'none',
                                        boxShadow: 'none',
                                    }}
                                />
                            </Box>
                        )}
                    </Box>
                



                {/* OTP Input Field - Only show when OTP is sent and not yet verified */}
                {isOtpSent && !isEmailVerified && (
                    <Box sx={{ display: 'flex', alignItems: 'flex-start', gap: 2, mb: 2 }}>
                        <Box sx={{ flexGrow: 1, mt: '8px' }}>
                            <TextInputComponent
                                fullWidth
                                label="Enter OTP"
                                placeholder="Enter 6-digit OTP"
                                value={otp}
                                onchange={onOtpChange}
                                error={otpError}
                                isError={!!otpError}
                                disabled={isVerifyingOtp}
                                inputProps={{
                                    maxLength: 6,
                                    inputMode: 'numeric',
                                    pattern: '\\d*'
                                }}
                                autoFocus
                            />
                        </Box>
                        <Box sx={{ minWidth: '120px', mt: '55px' }}>
                            <TextButtonComponet
                                fullWidth
                                text={isVerifyingOtp ? 'Verifying...' : 'Verify OTP'}
                                onButtonClick={handleVerifyOtp}
                                disabled={otp.length !== 6 || isVerifyingOtp}
                                style={{
                                    fontSize: '14px',
                                    fontWeight: 500,
                                    textTransform: 'none',
                                    boxShadow: 'none',
                                    backgroundColor: otp.length === 6 ? 'primary.main' : 'action.disabledBackground',
                                    color: 'white',
                                    '&:hover': {
                                        backgroundColor: 'primary.dark',
                                    },
                                }}
                            />
                        </Box>
                    </Box>
                )}
            </Box>

            {/* Show the rest of the form only after email is verified */}
            {isEmailVerified ? (
                <>
                    {/* Email Confirmation */}
                    <Box sx={{ 
                        mb: 3, 
                        p: 2, 
                        bgcolor: 'success.light', 
                        borderRadius: 1,
                        display: 'flex',
                        alignItems: 'center',
                        gap: 1
                    }}>
                        <span style={{ color: 'success.main' }}>✓</span>
                        <Typography variant="body2" color="text.secondary">
                            Email verified: {email}
                        </Typography>
                    </Box>

                    {/* Name Fields */}
                    <Box sx={{ display: 'flex', flexDirection: 'row', width: 1, justifyContent: 'space-between', mt: 3 }}>
                        <Box sx={{ flexGrow: 1, marginRight: 2 }}>
                            <TextInputComponent
                                label="First Name"
                                placeholder="Enter your first name"
                                value={fName}
                                onchange={onChangeFirstName}
                                type="text"
                                error="Please add your first name"
                                isError={fNameError}
                            />
                        </Box>

                        <Box sx={{ flexGrow: 1 }}>
                            <TextInputComponent
                                label="Last Name"
                                placeholder="Enter your last name"
                                value={lName}
                                onchange={onChangeLastName}
                                error="Please add your last name"
                                isError={lNameError}
                            />
                        </Box>
                    </Box>
                    
                    {/* Phone Number */}
                    <Box sx={{ mt: 3, mb: 3 }}>
                        <PhoneNumberComponent
                            label="WhatsApp/Phone Number"
                            name="phoneNumber"
                            value={phone}
                            placeholder="WhatsApp/Phone Number"
                            onChange={onPhoneChange}
                            defaultCountry="CA"
                            isError={phoneError}
                            error={'Please add valid WhatsApp/phone number'}
                        />
                    </Box>

                    <Box sx={{ display: 'flex', flexDirection: 'row', width: 1, justifyContent: 'space-between', marginTop: '22px' }}>
                        <Box sx={{ flexGrow: 1, marginRight: 2 }}>
                            <TextInputComponent
                                label="New Password"
                                placeholder="Create a password"
                                value={password}
                                onchange={onPasswordChange}
                                type="password"
                                error="Please add valid password"
                                isError={errorPassword}
                            />
                        </Box>
                        <Box sx={{ flexGrow: 1 }}>
                            <TextInputComponent
                                label="Confirm Password"
                                placeholder="Re-enter your password"
                                value={confirmPassword}
                                type="password"
                                onchange={onConfirmPassword}
                                error="Password doesn't match!"
                                isError={ConfirmPasswordError}
                            />
                        </Box>
                    </Box>

                    <p className="signup-price-subtext">
                        Note: The password must be minimum of 8 characters with minimum of 1 upper case, 
                        1 lower case, 1 number and a special character.
                    </p>

                </>
            ) : (
                // Show some space when OTP is being entered to prevent layout shift
                isOtpSent && !isEmailVerified && <Box sx={{ height: '120px' }} />
            )}
        </>
    )
})

export default SignUpFormOne;